import CreatorSwitchBankAccountModalComponent from "./CreatorSwitchBankAccountModalComponent";

export default CreatorSwitchBankAccountModalComponent;
